export default __webpack_public_path__ + "static/media/bedaya-landing-bg.e777aae7.svg";